export default function HeroSection() {
  return (
    <section
      id="accueil"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20minimalist%20elegant%20clock%20workshop%20interior%2C%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20wooden%20workbench%20with%20clock%20mechanisms%20and%20tools%2C%20soft%20cream%20and%20beige%20tones%2C%20architectural%20photography%20style%2C%20warm%20and%20inviting%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20professional%20interior%20design%20photo&width=1920&height=1080&seq=hero1&orientation=landscape"
          alt="Atelier d'horlogerie"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white/90 via-white/60 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16 pt-20">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-12 h-12 rounded-full border-2 border-brand-text flex items-center justify-center">
              <i className="ri-time-line text-brand-text text-xl" />
            </div>
            <span className="text-sm font-medium text-brand-muted uppercase tracking-widest">
              L'Art du Temps
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl font-bold text-brand-text leading-tight mb-6">
            Apprendre
            <br />
            <span className="text-brand-accent">l'Heure</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-muted leading-relaxed mb-8 max-w-lg">
            Découvrez notre horloge interactive et apprenez à lire l'heure en
            vous amusant. Un voyage ludique à travers le temps.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() =>
                document
                  .getElementById("horloge")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="px-8 py-4 bg-brand-accent text-white font-medium rounded-lg hover:bg-brand-accent/90 transition-all cursor-pointer whitespace-nowrap"
            >
              Découvrir l'Horloge
            </button>
            <button
              onClick={() =>
                document
                  .getElementById("jeu")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
              className="px-8 py-4 border-2 border-brand-text text-brand-text font-medium rounded-lg hover:bg-brand-text hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Jouer au Jeu
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}